import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import DoneIcon from '@mui/icons-material/Done';
import './SilentCloseConfirmForm.scss';

export default function SilentCloseConfirmForm(props) {
    const [cursor] = useState('auto');
    const className = 'silentCloseConfirmForm';
    const loading = !!props?.loading;

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                    sx: { backgroundColor: 'rgba(0, 0, 0, 0.6)' }
                }
            }}
        >
            <Fade in={props.open}>
                <Box className={className + '__container'}>
                    <Paper className={className + '__paper'} elevation={24}>
                        {/* Header */}
                        <Box className={className + '__header'}>
                            <Box className={className + '__headerContent'}>
                                <Box className={className + '__iconWrapper'}>
                                    <NotificationsOffOutlinedIcon className={className + '__headerIcon'} />
                                </Box>
                                <Box>
                                    <Typography className={className + '__title'}>
                                        Resolve This Stale Ticket?
                                    </Typography>
                                    <Typography className={className + '__subtitle'}>
                                        {props?.staleDays > 0
                                            ? `Nothing's happened here in ${props.staleDays} day${props.staleDays === 1 ? '' : 's'}`
                                            : "This ticket hasn't seen activity in a while"}
                                    </Typography>
                                </Box>
                            </Box>
                            <IconButton
                                onClick={props.closePopup}
                                className={className + '__closeBtn'}
                                size="small"
                                disabled={loading}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Divider />

                        {/* Body */}
                        <Box className={className + '__body'}>
                            <Box className={className + '__warning'}>
                                <WarningAmberRoundedIcon className={className + '__warningIcon'} />
                                <Box className={className + '__warningContent'}>
                                    <Typography className={className + '__warningTitle'}>
                                        Resolving normally will notify the reporter and agents
                                    </Typography>
                                    <Typography className={className + '__warningText'}>
                                        They'll get an email and WhatsApp message about this ticket closing — which
                                        can be a strange thing to receive out of the blue for something this old.
                                        Close it silently instead to skip those notifications; the ticket still gets
                                        marked resolved either way.
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Divider />

                        {/* Footer */}
                        <Box className={className + '__footer'}>
                            <Button
                                variant="text"
                                onClick={props.closePopup}
                                className={className + '__cancelBtn'}
                                disabled={loading}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={props?.onCloseNormally}
                                disabled={loading}
                                startIcon={<DoneIcon />}
                                className={className + '__normalBtn'}
                            >
                                Close Normally
                            </Button>
                            <Button
                                variant="contained"
                                onClick={props?.onSilentClose}
                                disabled={loading}
                                startIcon={<NotificationsOffOutlinedIcon />}
                                className={className + '__silentBtn'}
                            >
                                Silently Close
                            </Button>
                        </Box>
                    </Paper>
                </Box>
            </Fade>
        </Modal>
    );
}
